import PageHeader from "components/PageHeader";
import React from "react";
import { Helmet } from "react-helmet";
import styled from "styled-components/macro";
import { device } from "theme/Breakpoints";
import { colors } from "theme/Theme";

interface Props {}

const Policy: React.FC<Props> = ({}) => {
  return (
    <>
      <Helmet>
        <title>Плитика за Защита на Личните Данни</title>
      </Helmet>
      <PageHeader
        title={"“ИКЛИМА” ЕООД"}
        subtitle={"Политика за Защита на Личните Данни"}
      />
      <TermsAndConditionsContainer>
        <OpeningText className="text-sm">
          Опазването на личните данни и финансовата информация на нашите клиенти
          е от голямо значение за нас. Поради това, обработваме Вашата
          информация в пълно съответствие с приложимото законодателство.
          Конкретно: Общия регламент 2016/670 (по-известен като GDPR), Закона за
          защита на лични данни (ЗЗЛД) и Закона за електронната търговия (ЗЕТ).
          В следващите редове на тази декларация Ви информираме за най-важните
          аспекти от обработването на Вашите данни при използването на нашия
          уебсайт, от страна на “И КЛИМА” ЕООД (последващо Ние или Дружеството).
          С нея също така Ви информираме за сроковете и правните основания да
          събираме, обработваме, съхраняваме, използваме, унищожаваме и
          защитаваме личната Ви информация, доколкото с нея Вие не ни давате
          изричното си съгласие да вършим това.
        </OpeningText>

        <Paragraph>
          <ParagraphTitle className="text-body">
            Какво представляват личните данни?
          </ParagraphTitle>
          <ParagraphContent className="text-sm">
            Личните данни представляват информация, която пряко или косвено Ви
            идентифицира като физическо лице, тогава когато бъде комбинирана с
            друга информация като например Вашето име, пощенски адрес, адрес на
            електронна поща (e-mail), телефонен номер и др.
          </ParagraphContent>
        </Paragraph>

        <Paragraph>
          <ParagraphTitle className="text-body">
            Как обработваме Вашите лични данни?
          </ParagraphTitle>
          <ParagraphContent className="text-sm">
            Ние от „И КЛИМА“ ЕООД, като собственик на интернет страницата
            www.i-clima.com използваме Вашите лични данни единствено за целите
            на изпълнение на договора за доставка на стоки, по който Вие сте
            страна, както и за целите на последващ контакт с Вас, ако сте
            избрали да се свържете с нас на някои от нашите телефони или на
            имейла ни:
            <a href="mailto:office@i-clima.com">office@i-clima.com</a>.
            Гарантираме Ви, че ние не събираме и не обработваме допълнително
            лични данни, отколкото са ни необходими за изпълнение на така
            посочените в тази политика за защита на личните данни цели.
          </ParagraphContent>
        </Paragraph>

        <Paragraph>
          <ParagraphTitle className="text-body">
            Кой носи отговорност за личните Ви данни?
          </ParagraphTitle>
          <ParagraphContent className="text-sm">
            "И КЛИМА" ЕООД със седалище в гр. Карлово на ул. "Иван Вазов" 55, и
            с ЕИК: 160084566 е администратор на личните данни, които ни
            предоставяте, и носи отговорност за тях, съгласно приложимия Закон
            за защита на личните данни (ЗЗЛД) на Република България и Регламент
            (ЕС) 2016/679 на Европейския парламент на Съвета от 27 април 2016
            година относно защитата на физическите лица във връзка с
            обработването на лични данни.
          </ParagraphContent>
        </Paragraph>

        <Paragraph>
          <ParagraphTitle className="text-body">
            Кои категории лични данни обработваме ние?
          </ParagraphTitle>
          <ParagraphContent className="text-sm">
            <OrderedList>
              <ListItem className="text-sm">Две имена – име, фамилия</ListItem>
              <ListItem className="text-sm">
                Пощенски адрес (адрес за доставка и фактуриране)
              </ListItem>
              <ListItem className="text-sm">
                Адрес на електронна поща (e-mail)
              </ListItem>
              <ListItem className="text-sm">Телефон за връзка</ListItem>
              <ListItem className="text-sm">
                Данни за издаване на фактура на ФЛ – които включват и ЕГН, освен
                имена и постоянен адрес.
              </ListItem>
              <ListItem className="text-sm">
                Данни за издаване на фактура на ЮЛ – Име на фирмата, ЕИК, МОЛ,
                Адрес на фирмата, ДДС номер
              </ListItem>
            </OrderedList>
          </ParagraphContent>
        </Paragraph>

        <Paragraph>
          <ParagraphTitle className="text-body">
            Какви са целите и основанията на обработването?
          </ParagraphTitle>
          <ParagraphContent className="text-sm">
            <OrderedList>
              <ListItem className="text-sm">
                Обработване на поръчки, включващо приемане, подготовка,
                изпращане, доставка и фактуриране; Имената, адреса за доставка и
                телефонният номер са необходими и задължителни при регистриране
                на поръчка, за да бъде коректно обработена и изпратена до точния
                адрес посочен от клиента.
              </ListItem>
              <ListItem className="text-sm">
                Уточнения по поръчката: Възможно е наш служител да се свърже с
                Вас за уточнения по поръчката и нейната обработка, както на
                посочения от Вас телефон да се свърже фирмата-доставчик или да
                бъде изпратен SMS за пристигането на пратката в офис на куриер.
                Съгласието за предоставяне на тези данни на куриерската фирма е
                неотменна част от отношенията с „И КЛИМА“ ЕООД”. E-mail адреса е
                необходим за да изпратим потвърждение за получаване на поръчката
                Ви, а също така ще получите известие, когато пратката Ви бъде
                изпратена.
              </ListItem>
              <ListItem className="text-sm">
                Разрешаване на казуси, свързани с анулирания на поръчки и/или
                връщане на продуктите в съответствие със законовите разпоредби
                и/или възстановяване на стойността на продуктите съгласно
                законовите разпоредби
              </ListItem>

              <ListItem className="text-sm">
                За маркетинг цели: В допълнение към информацията, която Вие ни
                предоставите e възможно да събираме и информация по време на
                Вашето посещение на интернет сайта ни чрез инструменти за
                автоматично събиране на информация, които включват бисквитки,
                връзки, страници и други често ползвани инструменти за събиране
                на информация. Възможно е да изпращаме информация за продукти
                или рекламни кампании на посоченият при поръчката имейл адрес.
                По всяко време, Вие имате право да се откажете от тези
                съобщения, като посетите линка най-отдолу в имейла “Откажи се от
                абонамента/Unsubscribe from list”.
              </ListItem>

              <ListItem className="text-sm">
                Подобряване качеството на предлаганите от нас услуги:
                Информацията, която събираме служи да установим най-точно Вашите
                потребности и да отговорим възможно най-адекватно на Вашето
                търсене. Ние не събираме и не обработваме чувствителни данни,
                включени в специални категории лични данни в Общият регламент
                относно защитата на данните, като: лични данни, разкриващи расов
                или етнически произход, политически възгледи, религиозни или
                философски убеждения или членство в синдикални организации,
                обработването на генетични данни, биометрични данни за целите
                единствено на идентифицирането на физическо лице, данни за
                здравословното състояние или данни за сексуалния живот или
                сексуалната ориентация на физическото лице.
              </ListItem>
            </OrderedList>
          </ParagraphContent>
        </Paragraph>

        <Paragraph>
          <ParagraphTitle className="text-body">
            Какво се случва с данните Ви, когато се свържете се нас?
          </ParagraphTitle>
          <ParagraphContent className="text-sm">
            Когато ни пишете чрез формуляра на нашия уебсайт (Контакти) или ни
            изпратите имейл, ние съхраняваме данните Ви за периода, необходим за
            обработване на искането Ви, както и за да отговорим на Ваши
            последващи въпроси. Ние не споделяме тази информация с трети лица
            без Вашето изрично съгласие!
          </ParagraphContent>
        </Paragraph>

        <Paragraph>
          <ParagraphTitle className="text-body">
            Съхраняване на Вашите данни
          </ParagraphTitle>
          <ParagraphContent className="text-sm">
            Обръщаме внимание, че с цел облекчаване на процеса по поръчка и
            покупка, както и последващото изпълнение на договора с Вас,
            съхраняваме Вашия IP адрес, както и Вашите имена, адрес, имейл адрес
            и данни за използваното от Вас платежно средство, например номер на
            банковата Ви сметка. Предоставените от Вас данни са ни нужни, за да
            изпълним своите преддоговорни или договорни задължения спрямо Вас.
            Не предоставяме тези данни на трети лица, с изключение на:
            <OrderedList>
              <ListItem className="text-sm">
                Обработващия плащането доставчик на платежни услуги (банка)
              </ListItem>
              <ListItem className="text-sm">
                Куриерската фирма, с която Ви доставяме поръчката
              </ListItem>
              <ListItem className="text-sm">Нашия счетоводител</ListItem>
            </OrderedList>
            В определени случай е възможно да предоставим данните Ви и на
            следните получатели:
            <OrderedList>
              <ListItem className="text-sm">
                Доставчици на маркетингови услуги
              </ListItem>
              <ListItem className="text-sm">Доставчици на IT услуги</ListItem>
              <ListItem className="text-sm">
                Държавни органи и лица, при поискване на данните по законовия
                ред.
              </ListItem>
            </OrderedList>
            При незавършена поръчка оставяме въведените по нея данни за 30 дни и
            си запазваме правото да Ви информираме периодично за нейния статус,
            както и за Вашите опции вследствие на това. При завършена поръчка и
            изпълнен от наша страна договор на основание чл. 6, ал. 1, букви (а)
            и (б) от GDPR съхраняваме всички данни по правоотношението до
            изтичане на предвидения в чл. 12 от Закона за счетоводството ( ЗСч)
            10-годишен срок.
            <br></br>
            <br></br>
            Въпреки мерките, които прилагаме, „И КЛИМА” EООД не носи
            отговорност, ако трети лица или външни сайтове (Google Analytics;
            Google Ads; Facebook Ads) умишлено използват лична информация,
            свързана по някакъв начин с Вас и това противоречи на законовите
            норми и разпоредби.
            <a href="https://www.i-clima.com">www.i-clima.com</a>
            може да съдържа линкове и към други уеб сайтове, като ние не носим
            отговорност за тяхното съдържание.
          </ParagraphContent>
        </Paragraph>

        <Paragraph>
          <ParagraphTitle className="text-body">Бюлетин</ParagraphTitle>
          <ParagraphContent className="text-sm">
            Можете да се абонирате за нашия бюлетин, като попълните краткия
            формуляр на сайта. За да се абонирате, е нужно да предоставите
            Вашите имена, имейл адрес и съгласието Ви да изпращаме съответните
            съобщения.
            <br></br>
            <br></br>
            След абонирането Ви, ще изпратим потвърдителен имейл с линк, с чиято
            помощ да потвърдите регистрацията си.
            <br></br>
            <br></br>Можете по всяко едно време да се откажете от абонамента си,
            като изпратите имейл на
            <a href="mailto:office@i-clima.com">office@i-clima.com</a>, в който
            да изявите отказа си. Можете да използвате и бутона “Откажи се от
            абонамента/Unsubscribe from list”. Веднага след получаване на отказа
            Ви, ще заличим данните Ви във връзка с изпращането на нашия бюлетин.
          </ParagraphContent>
        </Paragraph>

        <Paragraph>
          <ParagraphTitle className="text-body">Вашите права</ParagraphTitle>
          <ParagraphContent className="text-sm">
            Имате право на достъп до Вашите данни, които обработваме, както и
            право на коригиране, изтриване (право „да бъдете забравени“),
            ограничаване на обработката, преносимост на данни, оттегляне на
            съгласието и възражение. В случай на възникнали въпроси относно
            политиката ни за защита на личните данни, можете по всяко едно време
            да се свържите с нас чрез начините, описани по-долу.
          </ParagraphContent>
        </Paragraph>

        <Paragraph>
          <ParagraphTitle className="text-body">
            Можете да се свържите с нас по всяко време по един от следните
            начини:
          </ParagraphTitle>
          <ParagraphContent className="text-sm">
            “И КЛИМА” ЕООД, Данни за контакт: Магазин гр. Карлово: ул. „Ген.
            Карцов“ 27, 4300 кв. Васил Левски, Карлово. Шоурум гр. Пловдив: бул.
            Руски 119 (срещу х-л Лайпциг), 4000 Център, Пловдив;
            <a href="mailto:office@i-clima.com">office@i-clima.com</a>, 0886 560
            510, 0889 26 99 46, 0882 930 771; МОЛ: Илия Тодоров Богдански
          </ParagraphContent>
        </Paragraph>
      </TermsAndConditionsContainer>
    </>
  );
};

export const TermsAndConditionsContainer = styled.div`
  margin: 0 10px;

  @media only screen and (${device.laptop}) {
    margin: 0 20px;
  }

  @media only screen and (${device.desktop}) {
    margin: 0;
  }
`;

export const OpeningText = styled.div`
  text-align: justify;
`;
export const Paragraph = styled.div`
  margin: 20px 0;
`;
export const ParagraphTitle = styled.h3`
  color: ${colors.light_blue};
  margin-bottom: 12px;
`;
export const ParagraphContent = styled.div`
  text-align: justify;
`;

export const OrderedList = styled.ol`
  margin: 10px 0;
  list-style: none;
  counter-reset: my-awesome-counter;
`;
export const ListItem = styled.li`
  counter-increment: my-awesome-counter;

  &::before {
    content: counter(my-awesome-counter) ". ";
    color: ${colors.light_blue};
    font-weight: bold;
  }
`;

export default Policy;
